import { TableHeader } from '../models';

export const ProjectTableHeadersConstant: TableHeader[] = [
  {
    key: 'createdAt',
    label: 'Date of creation',
    position: 'left',
  },
  {
    key: 'createdByUser.username',
    label: 'Created by',
  },
  {
    key: 'clientNameSearch',
    label: 'Client name',
  },
  {
    key: 'projectInfo',
    label: 'Project info',
  },
  {
    key: 'id',
    label: 'Project Number',
    position: 'left',
    required: true,
  },
  {
    key: 'purchaseOrder',
    label: 'Purchase order',
  },
  {
    key: 'battery.partNumber',
    label: 'Battery ref.',
  },
  {
    key: 'configurationSummary',
    label: 'Configuration summary',
  },
  {
    key: 'total',
    label: 'Total blocks',
  },
  {
    key: 'cableSection',
    label: 'Section (mm²)',
  },
  {
    key: 'installationType',
    label: 'Installation type',
  },
  {
    key: 'client.name',
    label: 'OEM Partner',
  },
  {
    key: 'projectStatus',
    label: 'Status',
  },
  {
    key: 'action',
    label: 'Actions',
    position: 'right',
    required: true,
  },
];
